import * as React from "react"

// COMPONENTS
import Layout from "../components/layout";
import { StaticImage } from "gatsby-plugin-image"
import Seo from "../components/Seo"

const AboutPage = () => {
  return (
    <Layout>
      <Seo title="About - N.Johnstone&Co" />
      <div className="about-page page-wrapper">
        <div className="container">
          <div className="row">
            <div className="about-nova col sm12">
              <div>
                <StaticImage placeholder="blurred" src="../images/nova_portrait.jpg" alt="nova" />
              </div>
              <div>
                <h1>Nova Johnstone</h1>
                <p>Halifax, NS</p>
                <hr />
                <p className="supporting-copy">
                  As a graduate of psychology and counselling I've been on a journey of helping others.
                  When my experience as an Executive Assistant began to intersect with my educational
                  background I found a unique platform to best serve brilliant founders of startups,
                  entrepreneurs and CEO's of not-for-profits and B-Corp organizations.
                  I believe that the demands on todays executive can easily lead to burnout and
                  exhaustion if systems and processes aren't streamlined, functional and clear.
                  I've been supporting C-suite executives and their teams worldwide before remote
                  working became the norm (hello Covid!) so, I understand the operational challenges
                  and needs of a remote first environment.
                  I look forward to learning more about you and your team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default AboutPage;